/* eslint-disable max-len */
import { html } from 'lit'

export const kulaCat = html`<svg
  width="513"
  height="518"
  viewBox="0 0 513 518"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M401.5 281.5H114C111.239 281.5 109 283.739 109 286.5V505C109 507.761 111.239 510 114 510H401.5C404.261 510 406.5 507.761 406.5 505V286.5C406.5 283.739 404.261 281.5 401.5 281.5Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M139.803 199.291L111.44 277.291C110.254 280.552 112.669 284 116.138 284H401.974C405.549 284 407.968 280.357 406.583 277.062L373.787 199.062C373.007 197.207 371.191 196 369.178 196H144.502C142.4 196 140.522 197.315 139.803 199.291Z"
    fill="#6B8789"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M12.1414 252.187L100.186 281.084C102.633 281.887 105.289 280.7 106.324 278.342L139.706 202.229C140.921 199.46 139.419 196.255 136.514 195.417L45.7804 169.235C43.3407 168.531 40.7609 169.768 39.7812 172.11L9.08768 245.508C7.96233 248.199 9.36996 251.278 12.1414 252.187Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M466.298 170.148L378.966 194.007C376.064 194.8 374.514 197.957 375.662 200.738L407.268 277.303C408.25 279.683 410.88 280.928 413.344 280.179L500.665 253.623C503.512 252.757 504.978 249.609 503.807 246.873L472.213 173.005C471.231 170.709 468.706 169.49 466.298 170.148Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M324.522 178.547C342.864 171.154 352.012 240.42 354.673 280.64C354.866 283.544 352.518 285.95 349.609 285.892L173.982 282.359C171.713 282.314 169.746 280.74 169.285 278.518C159.789 232.683 182.073 196.449 196.053 182.299C197.033 181.307 198.379 180.834 199.77 180.931C234.907 183.376 305.729 186.122 324.522 178.547Z"
    fill="#A1DCCD"
    stroke="#153E35"
    stroke-width="8"
  />
  <path
    d="M190.259 33.8254L181.637 81.2475C181.546 81.7463 181.38 82.2283 181.144 82.6772L171.573 100.909C171.197 101.625 171 102.423 171 103.233V125.5L173.765 145.314C173.917 146.407 174.427 147.419 175.216 148.192L199.489 171.999C199.828 172.331 200.213 172.614 200.631 172.838L241.589 194.745C242.507 195.236 243.555 195.428 244.587 195.295L303.679 187.67C304.545 187.559 305.366 187.222 306.061 186.695L346.754 155.824C347.867 154.98 348.576 153.709 348.709 152.319L354.398 93.064C354.465 92.3626 354.384 91.6549 354.158 90.9873L341.236 52.7002C341.08 52.2359 340.856 51.7972 340.571 51.3981L318.832 20.8801C316.909 18.1801 312.939 18.065 310.862 20.649L294.092 41.5188C293.092 42.7638 291.557 43.4559 289.961 43.3814L242.033 41.1417C240.169 41.0546 238.412 42.0123 237.475 43.6256L237.282 43.9596C234.895 48.0701 228.659 46.8447 228.005 42.1368L227.727 40.1313C227.579 39.0718 227.096 38.0874 226.348 37.3227L208.827 19.412C206.772 17.3109 203.356 17.4275 201.449 19.6637L191.374 31.4751C190.802 32.1464 190.417 32.9573 190.259 33.8254Z"
    fill="#A1DCCD"
    stroke="#153E35"
    stroke-width="8"
  />
  <path
    d="M180 78C165.667 98.8333 152.4 150.2 216 181C279.324 211.666 327.745 176.475 344.286 154.783C344.433 154.589 344.554 154.403 344.668 154.189C353.457 137.781 363.065 94.6679 342 74"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M355 106L379 94.5" stroke="#153E35" stroke-width="10" />
  <path d="M355 123.5H384" stroke="#153E35" stroke-width="10" />
  <path
    d="M178.5 83C178 69.8333 182.8 38 206 16"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M199.5 10C206.706 15.0485 227.656 34.132 228.5 62"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M229.5 44.0002C240.333 39.0002 267.8 32.3002 291 45.5002"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M341.5 85.5C347.763 79.9695 353.245 53.5268 310.5 6"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M292.5 61C293.5 47.1667 299.9 17.6 317.5 10"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M262 38.5V69.5" stroke="#153E35" stroke-width="16" />
  <path d="M139.5 94.5L165.5 103" stroke="#153E35" stroke-width="10" />
  <path d="M134 124H164.5" stroke="#153E35" stroke-width="10" />
  <path d="M144.5 152L169 141" stroke="#153E35" stroke-width="10" />
  <path d="M352 140L376.5 150" stroke="#153E35" stroke-width="10" />
  <path
    d="M168.259 282C162.995 249.954 163.572 184.29 208 178"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M315 179.635C329.774 175.248 360.917 191.801 355.339 286"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M229 131V99" stroke="#153E35" stroke-width="16" />
  <path d="M293 131V99" stroke="#153E35" stroke-width="16" />
  <path d="M274 141H250.5" stroke="#153E35" stroke-width="16" />
  <path d="M112 284H406" stroke="#153E35" stroke-width="16" />
</svg> `

export const fixItKulaCat = html`<svg
  width="513"
  height="518"
  viewBox="0 0 513 518"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M401.5 281.5H114C111.239 281.5 109 283.739 109 286.5V505C109 507.761 111.239 510 114 510H401.5C404.261 510 406.5 507.761 406.5 505V286.5C406.5 283.739 404.261 281.5 401.5 281.5Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M139.803 199.291L111.44 277.291C110.254 280.552 112.669 284 116.138 284H401.974C405.549 284 407.968 280.357 406.583 277.062L373.787 199.062C373.007 197.207 371.191 196 369.178 196H144.502C142.4 196 140.522 197.315 139.803 199.291Z"
    fill="#6B8789"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M12.1414 252.187L100.186 281.084C102.633 281.887 105.289 280.7 106.324 278.342L139.706 202.229C140.921 199.46 139.419 196.255 136.514 195.417L45.7804 169.235C43.3407 168.531 40.7609 169.768 39.7812 172.11L9.08768 245.508C7.96233 248.199 9.36996 251.278 12.1414 252.187Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M466.298 170.148L378.966 194.007C376.064 194.8 374.514 197.957 375.662 200.738L407.268 277.303C408.25 279.683 410.88 280.928 413.344 280.179L500.665 253.623C503.512 252.757 504.978 249.609 503.807 246.873L472.213 173.005C471.231 170.709 468.706 169.49 466.298 170.148Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M324.522 178.547C342.864 171.154 352.012 240.42 354.673 280.64C354.866 283.544 352.518 285.95 349.609 285.892L173.982 282.359C171.713 282.314 169.746 280.74 169.285 278.518C159.789 232.683 182.073 196.449 196.053 182.299C197.033 181.307 198.379 180.834 199.77 180.931C234.907 183.376 305.729 186.122 324.522 178.547Z"
    fill="#A1DCCD"
    stroke="#153E35"
    stroke-width="8"
  />
  <path
    d="M190.259 33.8254L181.637 81.2475C181.546 81.7463 181.38 82.2283 181.144 82.6772L171.573 100.909C171.197 101.625 171 102.423 171 103.233V125.5L173.765 145.314C173.917 146.407 174.427 147.419 175.216 148.192L199.489 171.999C199.828 172.331 200.213 172.614 200.631 172.838L241.589 194.745C242.507 195.236 243.555 195.428 244.587 195.295L303.679 187.67C304.545 187.559 305.366 187.222 306.061 186.695L346.754 155.824C347.867 154.98 348.576 153.709 348.709 152.319L354.398 93.064C354.465 92.3626 354.384 91.6549 354.158 90.9873L341.236 52.7002C341.08 52.2359 340.856 51.7972 340.571 51.3981L318.832 20.8801C316.909 18.1801 312.939 18.065 310.862 20.649L294.092 41.5188C293.092 42.7638 291.557 43.4559 289.961 43.3814L242.033 41.1417C240.169 41.0546 238.412 42.0123 237.475 43.6256L237.282 43.9596C234.895 48.0701 228.659 46.8447 228.005 42.1368L227.727 40.1313C227.579 39.0718 227.096 38.0874 226.348 37.3227L208.827 19.412C206.772 17.3109 203.356 17.4275 201.449 19.6637L191.374 31.4751C190.802 32.1464 190.417 32.9573 190.259 33.8254Z"
    fill="#A1DCCD"
    stroke="#153E35"
    stroke-width="8"
  />
  <path
    d="M180 78C165.667 98.8333 152.4 150.2 216 181C279.324 211.666 327.745 176.475 344.286 154.783C344.433 154.589 344.554 154.403 344.668 154.189C353.457 137.781 363.065 94.6679 342 74"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M355 106L379 94.5" stroke="#153E35" stroke-width="10" />
  <path d="M355 123.5H384" stroke="#153E35" stroke-width="10" />
  <path
    d="M178.5 83C178 69.8333 182.8 38 206 16"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M199.5 10C206.706 15.0485 227.656 34.132 228.5 62"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M229.5 44.0002C240.333 39.0002 267.8 32.3002 291 45.5002"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M341.5 85.5C347.763 79.9695 353.245 53.5268 310.5 6"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M292.5 61C293.5 47.1667 299.9 17.6 317.5 10"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M262 38.5V69.5" stroke="#153E35" stroke-width="16" />
  <path d="M139.5 94.5L165.5 103" stroke="#153E35" stroke-width="10" />
  <path d="M134 124H164.5" stroke="#153E35" stroke-width="10" />
  <path d="M144.5 152L169 141" stroke="#153E35" stroke-width="10" />
  <path d="M352 140L376.5 150" stroke="#153E35" stroke-width="10" />
  <path
    d="M168.259 282C162.995 249.954 163.572 184.29 208 178"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M315 179.635C329.774 175.248 360.917 191.801 355.339 286"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M229 131V99" stroke="#153E35" stroke-width="16" />
  <path d="M293 131V99" stroke="#153E35" stroke-width="16" />
  <path d="M274 141H250.5" stroke="#153E35" stroke-width="16" />
  <path d="M112 284H406" stroke="#153E35" stroke-width="16" />
</svg> `

export const searchKulaCat = html`<svg
  width="513"
  height="518"
  viewBox="0 0 513 518"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M401.5 281.5H114C111.239 281.5 109 283.739 109 286.5V505C109 507.761 111.239 510 114 510H401.5C404.261 510 406.5 507.761 406.5 505V286.5C406.5 283.739 404.261 281.5 401.5 281.5Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M139.803 199.291L111.44 277.291C110.254 280.552 112.669 284 116.138 284H401.974C405.549 284 407.968 280.357 406.583 277.062L373.787 199.062C373.007 197.207 371.191 196 369.178 196H144.502C142.4 196 140.522 197.315 139.803 199.291Z"
    fill="#6B8789"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M12.1414 252.187L100.186 281.084C102.633 281.887 105.289 280.7 106.324 278.342L139.706 202.229C140.921 199.46 139.419 196.255 136.514 195.417L45.7804 169.235C43.3407 168.531 40.7609 169.768 39.7812 172.11L9.08768 245.508C7.96233 248.199 9.36996 251.278 12.1414 252.187Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M466.298 170.148L378.966 194.007C376.064 194.8 374.514 197.957 375.662 200.738L407.268 277.303C408.25 279.683 410.88 280.928 413.344 280.179L500.665 253.623C503.512 252.757 504.978 249.609 503.807 246.873L472.213 173.005C471.231 170.709 468.706 169.49 466.298 170.148Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M324.522 178.547C342.864 171.154 352.012 240.42 354.673 280.64C354.866 283.544 352.518 285.95 349.609 285.892L173.982 282.359C171.713 282.314 169.746 280.74 169.285 278.518C159.789 232.683 182.073 196.449 196.053 182.299C197.033 181.307 198.379 180.834 199.77 180.931C234.907 183.376 305.729 186.122 324.522 178.547Z"
    fill="#A1DCCD"
    stroke="#153E35"
    stroke-width="8"
  />
  <path
    d="M190.259 33.8254L181.637 81.2475C181.546 81.7463 181.38 82.2283 181.144 82.6772L171.573 100.909C171.197 101.625 171 102.423 171 103.233V125.5L173.765 145.314C173.917 146.407 174.427 147.419 175.216 148.192L199.489 171.999C199.828 172.331 200.213 172.614 200.631 172.838L241.589 194.745C242.507 195.236 243.555 195.428 244.587 195.295L303.679 187.67C304.545 187.559 305.366 187.222 306.061 186.695L346.754 155.824C347.867 154.98 348.576 153.709 348.709 152.319L354.398 93.064C354.465 92.3626 354.384 91.6549 354.158 90.9873L341.236 52.7002C341.08 52.2359 340.856 51.7972 340.571 51.3981L318.832 20.8801C316.909 18.1801 312.939 18.065 310.862 20.649L294.092 41.5188C293.092 42.7638 291.557 43.4559 289.961 43.3814L242.033 41.1417C240.169 41.0546 238.412 42.0123 237.475 43.6256L237.282 43.9596C234.895 48.0701 228.659 46.8447 228.005 42.1368L227.727 40.1313C227.579 39.0718 227.096 38.0874 226.348 37.3227L208.827 19.412C206.772 17.3109 203.356 17.4275 201.449 19.6637L191.374 31.4751C190.802 32.1464 190.417 32.9573 190.259 33.8254Z"
    fill="#A1DCCD"
    stroke="#153E35"
    stroke-width="8"
  />
  <path
    d="M180 78C165.667 98.8333 152.4 150.2 216 181C279.324 211.666 327.745 176.475 344.286 154.783C344.433 154.589 344.554 154.403 344.668 154.189C353.457 137.781 363.065 94.6679 342 74"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M355 106L379 94.5" stroke="#153E35" stroke-width="10" />
  <path d="M355 123.5H384" stroke="#153E35" stroke-width="10" />
  <path
    d="M178.5 83C178 69.8333 182.8 38 206 16"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M199.5 10C206.706 15.0485 227.656 34.132 228.5 62"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M229.5 44.0002C240.333 39.0002 267.8 32.3002 291 45.5002"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M341.5 85.5C347.763 79.9695 353.245 53.5268 310.5 6"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M292.5 61C293.5 47.1667 299.9 17.6 317.5 10"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M262 38.5V69.5" stroke="#153E35" stroke-width="16" />
  <path d="M139.5 94.5L165.5 103" stroke="#153E35" stroke-width="10" />
  <path d="M134 124H164.5" stroke="#153E35" stroke-width="10" />
  <path d="M144.5 152L169 141" stroke="#153E35" stroke-width="10" />
  <path d="M352 140L376.5 150" stroke="#153E35" stroke-width="10" />
  <path
    d="M168.259 282C162.995 249.954 163.572 184.29 208 178"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M315 179.635C329.774 175.248 360.917 191.801 355.339 286"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M229 131V99" stroke="#153E35" stroke-width="16" />
  <path d="M293 131V99" stroke="#153E35" stroke-width="16" />
  <path d="M274 141H250.5" stroke="#153E35" stroke-width="16" />
  <path d="M112 284H406" stroke="#153E35" stroke-width="16" />
</svg> `

export const sleepyKulaCat = html`<svg
  width="513"
  height="518"
  viewBox="0 0 513 518"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M401.5 281.5H114C111.239 281.5 109 283.739 109 286.5V505C109 507.761 111.239 510 114 510H401.5C404.261 510 406.5 507.761 406.5 505V286.5C406.5 283.739 404.261 281.5 401.5 281.5Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M139.803 199.291L111.44 277.291C110.254 280.552 112.669 284 116.138 284H401.974C405.549 284 407.968 280.357 406.583 277.062L373.787 199.062C373.007 197.207 371.191 196 369.178 196H144.502C142.4 196 140.522 197.315 139.803 199.291Z"
    fill="#6B8789"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M12.1414 252.187L100.186 281.084C102.633 281.887 105.289 280.7 106.324 278.342L139.706 202.229C140.921 199.46 139.419 196.255 136.514 195.417L45.7804 169.235C43.3407 168.531 40.7609 169.768 39.7812 172.11L9.08768 245.508C7.96233 248.199 9.36996 251.278 12.1414 252.187Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M466.298 170.148L378.966 194.007C376.064 194.8 374.514 197.957 375.662 200.738L407.268 277.303C408.25 279.683 410.88 280.928 413.344 280.179L500.665 253.623C503.512 252.757 504.978 249.609 503.807 246.873L472.213 173.005C471.231 170.709 468.706 169.49 466.298 170.148Z"
    fill="#E7D1BE"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M324.522 178.547C342.864 171.154 352.012 240.42 354.673 280.64C354.866 283.544 352.518 285.95 349.609 285.892L173.982 282.359C171.713 282.314 169.746 280.74 169.285 278.518C159.789 232.683 182.073 196.449 196.053 182.299C197.033 181.307 198.379 180.834 199.77 180.931C234.907 183.376 305.729 186.122 324.522 178.547Z"
    fill="#A1DCCD"
    stroke="#153E35"
    stroke-width="8"
  />
  <path
    d="M190.259 33.8254L181.637 81.2475C181.546 81.7463 181.38 82.2283 181.144 82.6772L171.573 100.909C171.197 101.625 171 102.423 171 103.233V125.5L173.765 145.314C173.917 146.407 174.427 147.419 175.216 148.192L199.489 171.999C199.828 172.331 200.213 172.614 200.631 172.838L241.589 194.745C242.507 195.236 243.555 195.428 244.587 195.295L303.679 187.67C304.545 187.559 305.366 187.222 306.061 186.695L346.754 155.824C347.867 154.98 348.576 153.709 348.709 152.319L354.398 93.064C354.465 92.3626 354.384 91.6549 354.158 90.9873L341.236 52.7002C341.08 52.2359 340.856 51.7972 340.571 51.3981L318.832 20.8801C316.909 18.1801 312.939 18.065 310.862 20.649L294.092 41.5188C293.092 42.7638 291.557 43.4559 289.961 43.3814L242.033 41.1417C240.169 41.0546 238.412 42.0123 237.475 43.6256L237.282 43.9596C234.895 48.0701 228.659 46.8447 228.005 42.1368L227.727 40.1313C227.579 39.0718 227.096 38.0874 226.348 37.3227L208.827 19.412C206.772 17.3109 203.356 17.4275 201.449 19.6637L191.374 31.4751C190.802 32.1464 190.417 32.9573 190.259 33.8254Z"
    fill="#A1DCCD"
    stroke="#153E35"
    stroke-width="8"
  />
  <path
    d="M180 78C165.667 98.8333 152.4 150.2 216 181C279.324 211.666 327.745 176.475 344.286 154.783C344.433 154.589 344.554 154.403 344.668 154.189C353.457 137.781 363.065 94.6679 342 74"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M355 106L379 94.5" stroke="#153E35" stroke-width="10" />
  <path d="M355 123.5H384" stroke="#153E35" stroke-width="10" />
  <path
    d="M178.5 83C178 69.8333 182.8 38 206 16"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M199.5 10C206.706 15.0485 227.656 34.132 228.5 62"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M229.5 44.0002C240.333 39.0002 267.8 32.3002 291 45.5002"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M341.5 85.5C347.763 79.9695 353.245 53.5268 310.5 6"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M292.5 61C293.5 47.1667 299.9 17.6 317.5 10"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M262 38.5V69.5" stroke="#153E35" stroke-width="16" />
  <path d="M139.5 94.5L165.5 103" stroke="#153E35" stroke-width="10" />
  <path d="M134 124H164.5" stroke="#153E35" stroke-width="10" />
  <path d="M144.5 152L169 141" stroke="#153E35" stroke-width="10" />
  <path d="M352 140L376.5 150" stroke="#153E35" stroke-width="10" />
  <path
    d="M168.259 282C162.995 249.954 163.572 184.29 208 178"
    stroke="#153E35"
    stroke-width="16"
  />
  <path
    d="M315 179.635C329.774 175.248 360.917 191.801 355.339 286"
    stroke="#153E35"
    stroke-width="16"
  />
  <path d="M229 131V99" stroke="#153E35" stroke-width="16" />
  <path d="M293 131V99" stroke="#153E35" stroke-width="16" />
  <path d="M274 141H250.5" stroke="#153E35" stroke-width="16" />
  <path d="M112 284H406" stroke="#153E35" stroke-width="16" />
</svg> `

export const kulaCatWarning = html`
  <svg
    width="513"
    height="518"
    viewBox="0 0 513 518"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M401.5 281.5H114C111.239 281.5 109 283.739 109 286.5V505C109 507.761 111.239 510 114 510H401.5C404.261 510 406.5 507.761 406.5 505V286.5C406.5 283.739 404.261 281.5 401.5 281.5Z"
      fill="#E7D1BE"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M139.803 199.291L111.44 277.291C110.254 280.552 112.669 284 116.138 284H401.974C405.549 284 407.968 280.357 406.583 277.062L373.787 199.062C373.007 197.207 371.191 196 369.178 196H144.502C142.4 196 140.522 197.315 139.803 199.291Z"
      fill="#6B8789"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M12.1414 252.187L100.186 281.084C102.633 281.887 105.289 280.7 106.324 278.342L139.706 202.229C140.921 199.46 139.419 196.255 136.514 195.417L45.7804 169.235C43.3407 168.531 40.7609 169.768 39.7812 172.11L9.08768 245.508C7.96233 248.199 9.36996 251.278 12.1414 252.187Z"
      fill="#E7D1BE"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M466.298 170.148L378.966 194.007C376.064 194.8 374.514 197.957 375.662 200.738L407.268 277.303C408.25 279.683 410.88 280.928 413.344 280.179L500.665 253.623C503.512 252.757 504.978 249.609 503.807 246.873L472.213 173.005C471.231 170.709 468.706 169.49 466.298 170.148Z"
      fill="#E7D1BE"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M324.522 178.547C342.864 171.154 352.012 240.42 354.673 280.64C354.866 283.544 352.518 285.95 349.609 285.892L173.982 282.359C171.713 282.314 169.746 280.74 169.285 278.518C159.789 232.683 182.073 196.449 196.053 182.299C197.033 181.307 198.379 180.834 199.77 180.931C234.907 183.376 305.729 186.122 324.522 178.547Z"
      fill="#A1DCCD"
      stroke="#153E35"
      stroke-width="8"
    />
    <path
      d="M190.259 33.8254L181.637 81.2475C181.546 81.7463 181.38 82.2283 181.144 82.6772L171.573 100.909C171.197 101.625 171 102.423 171 103.233V125.5L173.765 145.314C173.917 146.407 174.427 147.419 175.216 148.192L199.489 171.999C199.828 172.331 200.213 172.614 200.631 172.838L241.589 194.745C242.507 195.236 243.555 195.428 244.587 195.295L303.679 187.67C304.545 187.559 305.366 187.222 306.061 186.695L346.754 155.824C347.867 154.98 348.576 153.709 348.709 152.319L354.398 93.064C354.465 92.3626 354.384 91.6549 354.158 90.9873L341.236 52.7002C341.08 52.2359 340.856 51.7972 340.571 51.3981L318.832 20.8801C316.909 18.1801 312.939 18.065 310.862 20.649L294.092 41.5188C293.092 42.7638 291.557 43.4559 289.961 43.3814L242.033 41.1417C240.169 41.0546 238.412 42.0123 237.475 43.6256L237.282 43.9596C234.895 48.0701 228.659 46.8447 228.005 42.1368L227.727 40.1313C227.579 39.0718 227.096 38.0874 226.348 37.3227L208.827 19.412C206.772 17.3109 203.356 17.4275 201.449 19.6637L191.374 31.4751C190.802 32.1464 190.417 32.9573 190.259 33.8254Z"
      fill="#A1DCCD"
      stroke="#153E35"
      stroke-width="8"
    />
    <path
      d="M180 78C165.667 98.8333 152.4 150.2 216 181C279.324 211.666 327.745 176.475 344.286 154.783C344.433 154.589 344.554 154.403 344.668 154.189C353.457 137.781 363.065 94.6679 342 74"
      stroke="#153E35"
      stroke-width="16"
    />
    <path d="M355 106L379 94.5" stroke="#153E35" stroke-width="10" />
    <path d="M355 123.5H384" stroke="#153E35" stroke-width="10" />
    <path
      d="M178.5 83C178 69.8333 182.8 38 206 16"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M199.5 10C206.706 15.0485 227.656 34.132 228.5 62"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M229.5 44.0002C240.333 39.0002 267.8 32.3002 291 45.5002"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M341.5 85.5C347.763 79.9695 353.245 53.5268 310.5 6"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M292.5 61C293.5 47.1667 299.9 17.6 317.5 10"
      stroke="#153E35"
      stroke-width="16"
    />
    <path d="M262 38.5V69.5" stroke="#153E35" stroke-width="16" />
    <path d="M139.5 94.5L165.5 103" stroke="#153E35" stroke-width="10" />
    <path d="M134 124H164.5" stroke="#153E35" stroke-width="10" />
    <path d="M144.5 152L169 141" stroke="#153E35" stroke-width="10" />
    <path d="M352 140L376.5 150" stroke="#153E35" stroke-width="10" />
    <path
      d="M168.259 282C162.995 249.954 163.572 184.29 208 178"
      stroke="#153E35"
      stroke-width="16"
    />
    <path
      d="M315 179.635C329.774 175.248 360.917 191.801 355.339 286"
      stroke="#153E35"
      stroke-width="16"
    />
    <path d="M229 131V99" stroke="#153E35" stroke-width="16" />
    <path d="M293 131V99" stroke="#153E35" stroke-width="16" />
    <path d="M274 141H250.5" stroke="#153E35" stroke-width="16" />
    <path d="M112 284H406" stroke="#153E35" stroke-width="16" />
  </svg>
`
